import { describeRecurrence, localDateParts, type TaskDTO } from '@hearth/shared';
import { Repeat } from 'lucide-react';
import { Tooltip } from '../../components/ui';

/** Marks an occurrence of a repeating entry; the tooltip says how it repeats. */
export function TaskRepeatIcon({ task }: { task: Pick<TaskDTO, 'seriesId' | 'recurrence' | 'dueAt'> }) {
  if (!task.seriesId || !task.recurrence || !task.dueAt) return null;
  const label = describeRecurrence(task.recurrence, localDateParts(new Date(task.dueAt)));
  return (
    <Tooltip content={label}>
      <span role="img" tabIndex={0} aria-label={label} className="inline-flex rounded-sm text-slate-400 focus-visible:outline-2 focus-visible:outline-ember-500">
        <Repeat className="size-3.5" aria-hidden />
      </span>
    </Tooltip>
  );
}
